import * as AuthActions from './auth/actions';
import * as PaymentActions from './paymentRequest/actions';
import * as TemplateActions from './template/actions';

export const ActionCreators = Object.assign(
  {},
  AuthActions,
    PaymentActions,
    TemplateActions
);
